import React, { useState, useContext } from "react";
import StateList from "./StateList";
import CreateStateForm from "./CreateStateForm";
import EditStateForm from "./EditStateForm";
import { AuthContext } from "../../contexts/AuthContext";

const StatesPage = () => {
  const [activeTab, setActiveTab] = useState("list");
  const [editingState, setEditingState] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { user } = useContext(AuthContext);
  const isPrimary = user?.is_primary;

  const handleStateCreated = () => {
    setActiveTab("list");
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleStateUpdated = () => {
    setEditingState(null);
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col">
          <h2>State Management</h2>
          <p className="text-muted">
            Manage US states and territories for address selection.
            {!isPrimary && " (View-only access)"}
          </p>
        </div>
      </div>

      {/* Global Data Notice */}
      <div
        className="alert alert-info d-flex align-items-center mb-4"
        role="alert"
      >
        <i className="bi bi-globe fs-4 me-3"></i>
        <div>
          <strong>Global Reference Data:</strong> States are shared across all
          tenants. Only primary tenant users can make modifications.
        </div>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("list");
              setEditingState(null);
            }}
          >
            <i className="bi bi-list-ul"></i> State List
          </button>
        </li>
        {isPrimary && (
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "create" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("create");
                setEditingState(null);
              }}
            >
              <i className="bi bi-plus-circle"></i> Create State
            </button>
          </li>
        )}
      </ul>

      {/* Tab Content */}
      {activeTab === "list" && (
        <>
          {!editingState ? (
            <StateList
              onEdit={(state) => {
                if (isPrimary) {
                  setEditingState(state);
                }
              }}
              refreshTrigger={refreshTrigger}
            />
          ) : (
            <EditStateForm
              state={editingState}
              onCancel={() => setEditingState(null)}
              onUpdated={handleStateUpdated}
            />
          )}
        </>
      )}

      {activeTab === "create" && isPrimary && (
        <CreateStateForm onSuccess={handleStateCreated} />
      )}

      {/* Primary Tenant Info */}
      {!isPrimary && (
        <div className="alert alert-warning mt-4" role="alert">
          <i className="bi bi-shield-lock"></i> You must be a member of the
          primary tenant to manage states. Contact your system administrator for
          assistance.
        </div>
      )}

      {/* HIPAA Compliance Footer */}
      <div className="mt-5 p-3 bg-light rounded">
        <h6 className="text-muted">
          <i className="bi bi-shield-check"></i> HIPAA Compliance & Security
        </h6>
        <small className="text-muted">
          <ul className="mb-0">
            <li>All state modifications are logged for audit purposes</li>
            <li>States are global reference data (no PHI)</li>
            <li>Changes affect all tenants system-wide</li>
            <li>Only primary tenant users can modify states</li>
          </ul>
        </small>
      </div>
    </div>
  );
};

export default StatesPage;
